const WebsocketConnection = ({
  webSocket,
  onMessage,
  onError,
}) => {

  const handlers = {
    ping: () => {
      
    },
    error: ({body}) => onError(body),
    pubsubMessage: ({
      channel,
      messageType,
      body,
    }) => {
      onMessage({
        channel,
        messageType,
        body,
      })
    }
  }

  const sendMessage = (handler, message) => {
    webSocket.send(JSON.stringify({
      ...message,
      handler,
    }))
  }

  const readMessage = ({
    handler,
    channel,
    messageType,
    body,
  }) => {
    const handlerFunction = handlers[handler]
    if(!handlerFunction) {
      handlers.error({
        error: `no message handler found for ${handler}`
      })
      return
    }
    handlerFunction({
      channel,
      messageType,
      body,
    })
  }

  webSocket.addEventListener('message', ev => {
    let message = null
    try {
      message = JSON.parse(ev.data)
    } catch (e) {
      console.error(`error decoding JSON ${e.toString()}`)
      console.error(ev.data)
      return
    }
    readMessage(message)
  })

  return {
    sendMessage,
    subscribe: (channel) => {
      sendMessage('subscribe', {
        channel,
      })
    },
    unsubscribe: (channel) => {
      sendMessage('unsubscribe', {
        channel,
      })
    }
  }
}

export default WebsocketConnection